import React from 'react';
import TextInfo, {
  TEXT_COLOR,
  TEXT_DISPLAY,
  TEXT_SIZE,
  TEXT_ALIGN,
} from '@gcloud-npm/components.text';
import Button, {
  BUTTON_COLOR,
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
} from '@bitComponents/unifiedComponents/Button';
import './NetworkError.scss';

const NetworkError = ({ retry }) => {
  return (
    <div className="NetworkError uxux">
      <div className="container">
        <TextInfo
          text="¡Vaya! Parece que tu conexión va muy lenta. Te sugerimos que recargues contenido para intentar resolverlo."
          color={TEXT_COLOR.WHITE}
          display={TEXT_DISPLAY.BLOCK}
          size={TEXT_SIZE.TITLE6}
          align={TEXT_ALIGN.CENTER}
        />
        <Button
          label="Recargar contenido"
          color={BUTTON_COLOR.WHITE_BLUE}
          size={{
            w: BUTTON_WIDTH.MEDIUM,
            h: BUTTON_HEIGHT.MEDIUM,
          }}
          className="ReloadButton"
          onClick={retry}
          taggingInfo={{ debug: true }}
        />
      </div>
      <svg
        id="fondo-azul"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="1920.796"
        height={160}
        viewBox="0 0 1920.796 160"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Rectángulo_3844"
              data-name="Rectángulo 3844"
              width="1920.796"
              height={160}
              fill="none"
            />
          </clipPath>
        </defs>
        <rect
          id="skeletonCurvasV2"
          data-name="Rectángulo 3843"
          width={1920}
          height={160}
          fill="#019df4"
        />
        <g id="Grupo_10109" data-name="Grupo 10109" clipPath="url(#clip-path)">
          <path
            id="Trazado_8397"
            data-name="Trazado 8397"
            d="M1337.247,107.876c71.019,6.193,137.543-15.633,188.43-25.5,26.057-5.052,56.839-10.68,90.6-9.918,36.59.825,68.768,8.64,95.176,15.8,35.428,9.606,69.493,22.1,113.06,28.8,30.857,4.748,64.389,4.268,96.282,2.842V107.518q-4.369.3-8.761.575c-53.664,3.351-92.725.14-138.008-10.854-47.26-11.473-93.09-28.087-149.619-30.055-65.172-2.268-124.763,17.531-177.11,28.313-22.767,4.689-47.868,9.561-76.408,10.895-25.641,1.2-50.089-1.976-73.969-5.294-50.076-6.958-123.279-22.217-174.564-33.483,22.593,5.079,47,10.524,64.417,14.3,45.559,9.878,96.6,21.263,150.472,25.961"
            fill="#0b2739"
          />
          <path
            id="Trazado_8398"
            data-name="Trazado 8398"
            d="M1122.358,67.615c-31.83-7.155-60.058-13.581-60.058-13.581s24.87,5.851,60.058,13.581"
            fill="#0b2739"
          />
          <path
            id="Trazado_8399"
            data-name="Trazado 8399"
            d="M1920.8,130.609q-10.64.474-21.393.788c-56.688,1.606-95.138-5.552-137.361-17.566-44.73-12.727-93.034-30.941-150.7-32.026-63.445-1.195-120.344,16.873-175.762,26.33-22.1,3.772-47.294,7.479-74.414,7.221-25.037-.239-50.148-4.733-71.893-8.508-78.706-13.662-214.961-50.135-224.1-52.59h-.028c9.692,2.759,167.6,47.5,262.8,60.692,67.013,9.287,129.865-7.638,180.172-16.853,26.893-4.927,57.906-10.58,91.618-10.813,37.874-.261,71.233,7.72,97.68,15.21,36.276,10.274,68.445,23.176,109.3,32.384,34.994,7.886,70.733,9.085,111.3,8.408.935-.016,1.86-.043,2.793-.061Z"
            fill="#0b2739"
          />
          <path
            id="Trazado_8400"
            data-name="Trazado 8400"
            d="M1392.057,128.486c31.55-1.7,59.806-6.649,86.935-11.116,28.916-4.761,58.434-10.222,91.836-12.243,38.909-2.354,71.764,2.886,100.914,10.581,47.072,12.426,87.145,32.609,141.45,44.292h106.486v-3.829c-15.777.34-31.638.373-47.569-.006-120.983-2.878-170.429-61.338-285.888-57.379-61.948,2.125-112.377,17.8-172.74,24.593-53.052,5.972-94.044-1.179-139.969-11.181C1196.8,95.491,1062.3,54.033,1062.3,54.033s155.039,49.855,247.78,67.734c26.866,5.18,51.123,8.38,81.978,6.719"
            fill="#0b2739"
          />
          <path
            id="Trazado_8401"
            data-name="Trazado 8401"
            d="M1376.53,139.846c30.806.419,59.753-3.374,86.233-6.969,60.879-8.264,121.924-18.893,184.126-4.732,36.782,8.373,65.8,20.424,95.481,31.855h26.865c-64.335-20.989-116.259-50.751-206.405-44.7-56.938,3.824-106.88,17.679-167.8,20.725-51.525,2.576-94.926-9.151-133.234-19.05C1189.735,98.354,1064.6,54.258,1064.6,54.258s144.49,52.658,231.44,73.385c24.234,5.777,49.316,11.779,80.486,12.2"
            fill="#0b2739"
          />
          <path
            id="Trazado_8402"
            data-name="Trazado 8402"
            d="M411.6,46.085C361.51,40.63,314.588,59.856,278.7,68.547,260.315,73,238.6,77.956,214.789,77.285c-25.808-.727-48.5-7.611-67.131-13.919C122.669,54.9,98.642,43.9,67.912,37.993,46.147,33.811,22.5,34.234,0,35.489V46.4q3.083-.263,6.179-.506c37.852-2.952,65.4-.123,97.344,9.561C136.857,65.561,169.183,80.2,209.055,81.93c45.969,2,88-15.443,124.923-24.94,16.059-4.131,33.764-8.423,53.894-9.6,18.086-1.056,35.33,1.74,52.173,4.663,35.322,6.129,86.955,19.57,123.128,29.5-15.936-4.474-33.151-9.271-45.436-12.6C485.6,60.252,449.6,50.223,411.6,46.085"
            fill="#0b2739"
          />
          <path
            id="Trazado_8403"
            data-name="Trazado 8403"
            d="M563.173,81.551c22.451,6.3,42.362,11.963,42.362,11.963s-17.543-5.154-42.362-11.963"
            fill="#0b2739"
          />
          <path
            id="Trazado_8404"
            data-name="Trazado 8404"
            d="M0,26.06q7.5-.418,15.09-.694c39.984-1.415,67.1,4.89,96.886,15.473,31.55,11.212,65.621,27.256,106.3,28.212,44.75,1.053,84.883-14.863,123.972-23.194,15.591-3.322,33.359-6.588,52.488-6.36,17.66.21,35.372,4.168,50.709,7.494,55.515,12.035,151.621,44.163,158.069,46.326h.02c-6.835-2.43-118.216-41.842-185.361-53.463-47.267-8.181-91.6,6.728-127.083,14.846-18.969,4.339-40.844,9.32-64.622,9.524-26.715.23-50.244-6.8-68.9-13.4C131.982,41.776,109.291,30.41,80.476,22.3c-24.683-6.948-49.891-8-78.506-7.407-.659.014-1.312.038-1.97.054Z"
            fill="#0b2739"
          />
          <path
            id="Trazado_8405"
            data-name="Trazado 8405"
            d="M372.943,27.93c-22.253,1.5-42.184,5.857-61.319,9.792-20.4,4.194-41.216,9-64.776,10.784-27.444,2.074-50.618-2.541-71.179-9.32C142.467,28.24,114.2,10.461,75.9.17H.789V3.542c11.128-.3,22.316-.328,33.552.006,85.335,2.535,120.212,54.032,201.65,50.544,43.694-1.871,79.264-15.678,121.841-21.664,37.419-5.26,66.333,1.039,98.726,9.85C510.67,56.995,605.535,93.515,605.535,93.515S496.179,49.6,430.766,33.848c-18.95-4.562-36.059-7.381-57.823-5.918"
            fill="#0b2739"
          />
          <path
            id="Trazado_8406"
            data-name="Trazado 8406"
            d="M383.895,17.923c-21.73-.369-42.147,2.972-60.824,6.139-42.941,7.28-86,16.643-129.872,4.169-25.944-7.377-46.41-17.992-67.347-28.062H106.9c45.378,18.49,82,44.707,145.586,39.374,40.161-3.368,75.387-15.573,118.356-18.256,36.342-2.269,66.955,8.061,93.976,16.782,50.828,16.4,139.088,55.248,139.088,55.248S501.995,46.931,440.664,28.672C423.571,23.584,405.88,18.3,383.895,17.923"
            fill="#0b2739"
          />
        </g>
      </svg>
    </div>
  );
};

export default NetworkError;
